import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';

import { LoginComponent } from './login.component';
import { ValidationMessageComponent } from './validation-message/validation-message.component';
import { ShareModule } from './../shared/shared.module';

@NgModule({
  declarations: [LoginComponent, ValidationMessageComponent],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, ShareModule]
})
export class LoginModule {}



// WEBPACK FOOTER //
// ./src/app/login/login.module.ts